/**
 * API Client Configuration
 *
 * Configures the @hey-api generated client with:
 * - Base URL from environment
 * - Auth token injection via the auth callback
 */

import { client } from '@/api/client.gen';
import { createConfig } from '@/api/client';

// Use empty string for local dev to leverage Vite proxy (avoids CORS issues)
// In production, VITE_API_URL should be set to the actual backend URL
const API_BASE_URL = import.meta.env.VITE_API_URL || '';

// Token storage (in-memory for security)
let authToken: string | null = null;

// Configure the client with base URL and auth callback
// The auth callback is used by hey-api for requests with security defined
client.setConfig(
  createConfig({
    baseUrl: API_BASE_URL,
    // Auth callback - returns the raw token, hey-api adds "Bearer " prefix for bearer scheme
    auth: () => authToken ?? undefined,
  })
);

/**
 * Set the auth token for API requests.
 * Called after Clerk authentication.
 */
export function setAuthToken(token: string | null) {
  authToken = token;
}

/**
 * Get the current auth token.
 */
export function getAuthToken(): string | null {
  return authToken;
}

/**
 * Check if auth token is set (for use with query enabled option).
 */
export function isAuthenticated(): boolean {
  return authToken !== null;
}

/**
 * Clear the auth token (on logout).
 */
export function clearAuthToken() {
  authToken = null;
}

// Re-export client for direct use if needed
export { client };
